/**
 * Constantes de paiement synchronisées avec le backend
 * ⚠️ ATTENTION: Ces constantes DOIVENT correspondre exactement 
 * à celles définies dans backend/constants/enums.js
 */

// Types de paiement - Synchronisé avec backend/constants/enums.js
export const PAYMENT_TYPES = {
  RENTAL: 'rental',
  DEPOSIT: 'deposit',
  PENALTY: 'penalty',
  COMMISSION: 'commission',
  REFUND: 'refund',
  TAX: 'tax',
  DAMAGE_COMPENSATION: 'damage_compensation',
  DEPOSIT_REFUND: 'deposit_refund',
  RENTAL_REFUND: 'rental_refund',
  COMMISSION_REFUND: 'commission_refund'
};

// Méthodes de paiement - Synchronisé avec backend/constants/enums.js
export const PAYMENT_METHODS = {
  STRIPE: 'stripe',
  CASH: 'cash',
  VIREMENT: 'virement',
  CARD: 'card',
  BANK_TRANSFER: 'bank_transfer',
  ADMIN_ADJUSTMENT: 'admin_adjustment',
  DEPOSIT_CAPTURE: 'deposit_capture',
  STRIPE_REFUND: 'stripe_refund',
  AUTOMATIC_CREDIT: 'automatic_credit'
};

// Statuts des paiements - Synchronisé avec backend/constants/enums.js
export const PAYMENT_STATUSES = {
  PENDING: 'pending',
  COMPLETED: 'completed',
  FAILED: 'failed',
  PARTIAL: 'partial',
  REFUNDED: 'refunded',
  CANCELLED: 'cancelled',
  SUCCEEDED: 'succeeded',
  NO_REFUND_NEEDED: 'no_refund_needed'
};

// Devises supportées - Synchronisé avec backend/constants/enums.js
export const CURRENCIES = {
  EUR: 'EUR',
  USD: 'USD',
  GBP: 'GBP'
};

// Distinction entre méthodes Stripe et Cash
export const STRIPE_METHODS = [
  PAYMENT_METHODS.STRIPE,
  PAYMENT_METHODS.CARD,
  PAYMENT_METHODS.STRIPE_REFUND,
  PAYMENT_METHODS.DEPOSIT_CAPTURE
];

export const CASH_METHODS = [
  PAYMENT_METHODS.CASH,
  PAYMENT_METHODS.VIREMENT,
  PAYMENT_METHODS.BANK_TRANSFER
];

// Statuts considérés comme succès
export const SUCCESS_STATUSES = [
  PAYMENT_STATUSES.COMPLETED,
  PAYMENT_STATUSES.SUCCEEDED
];

// Statuts considérés comme en cours
export const PENDING_STATUSES = [
  PAYMENT_STATUSES.PENDING,
  PAYMENT_STATUSES.PARTIAL
];

// Types de paiements entrants (renter paye)
export const RENTER_PAYMENT_TYPES = [
  PAYMENT_TYPES.RENTAL,
  PAYMENT_TYPES.DEPOSIT,
  PAYMENT_TYPES.PENALTY,
  PAYMENT_TYPES.COMMISSION,
  PAYMENT_TYPES.TAX
];

// Types de paiements sortants (remboursements)
export const REFUND_PAYMENT_TYPES = [
  PAYMENT_TYPES.REFUND,
  PAYMENT_TYPES.DEPOSIT_REFUND,
  PAYMENT_TYPES.RENTAL_REFUND,
  PAYMENT_TYPES.COMMISSION_REFUND
];

// Statuts des réservations - Synchronisé avec backend/constants/reservationEnums.js
export const RESERVATION_STATUSES = {
  PENDING: 'pending',
  CONFIRMED: 'confirmed',
  ACTIVE: 'active',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled',
  REFUNDED: 'refunded',
  EXPIRED: 'expired',
  PAYMENT_FAILED: 'payment_failed'
};

// Statuts des dépôts/cautions - Synchronisé avec backend/constants/depositEnums.js
export const DEPOSIT_STATUSES = {
  PENDING: 'pending',
  PAID: 'paid',
  REFUNDED: 'refunded',
  WITHHELD: 'withheld',
  HELD: 'held',
  PARTIALLY_CAPTURED: 'partially_captured',
  RELEASED: 'released',
  CANCELLED: 'cancelled'
};
